// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1hvRP","choiceBoxes":"toolbarselects_choiceBoxes__1Q5i2","simpleField":"toolbarselects_simpleField__dOArQ"};